"use client";

import { ReviewListPage } from "@/components/reviews/review-list-page";

interface Props {
  hiiveSlug: string;
  hiiveName: string;
  isAuthenticated: boolean;
}

export function HiiveReviewsTabClient({
  hiiveSlug,
  hiiveName,
  isAuthenticated,
}: Props) {
  // ReviewListPage fetches its own data (and handles all filtering client-side
  // with debounced search + keep-previous loading), so this tab is just a thin
  // wrapper. No initialData is passed here — the tab mounts on user click, well
  // after the page navigation settles, so the first fetch is safe.
  return (
    <ReviewListPage
      target={{ targetType: "hiive", hiiveSlug }}
      title={`${hiiveName} reviews`}
      writeHref={`/hiives/${hiiveSlug}/reviews/write`}
      backHref={`/hiives/${hiiveSlug}`}
      backLabel="Back to hiive"
      isAuthenticated={isAuthenticated}
      inline
      reviewBaseHref={`/hiives/${hiiveSlug}/reviews`}
    />
  );
}
